module.exports = __webpack_public_path__ + "static/img/pic_02.7def99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_02.jpg
// module id = 608
// module chunks = 1